import React from "react";

export default function MiniProfile() {
  return (
    <div
      id="profile"
      className="flex flex-col items-center px-6 py-8 bg-mesanfaz-gray-2 lg:flex-row sm:px-8 md:px-12 md:py-12"
    >
      <div className="w-40 h-40 overflow-hidden border-2 rounded-full border-mesanfaz-black xl:w-52 2xl:w-80 xl:h-52 2xl:h-80">
        <img
          className="object-cover w-40 h-40 transition-all duration-1000 rounded-full cursor-pointer xl:w-52 2xl:w-80 xl:h-52 2xl:h-80 hover:scale-110"
          src={process.env.PUBLIC_URL + "/mine.png"}
          alt="My Profile"
        />
      </div>
      <div className="flex flex-1 text-justify md:items-center lg:ml-4 xl:ml-6 2xl:ml-8 max-md:pt-4 max-lg:pt-6">
        Hello 👋. My name is M. Ichsan Fauzan 🙋. I am 22 ✨. I was born 👶 and
        grew 🧍 in Lampung 🐘🏔️. I like programming 🧑‍💻, watching movies 🍿,
        listen a music 🎧 and I also always want to learn something new 💡🤔. I
        am open to Job Opportunities where I can contribute 🧑‍💻, learn 📖 and
        grow 📈. If there is an opportunity that matches my skills 💪 and
        experience 💼 then feel free to contact me 📞.
      </div>
    </div>
  );
}
